import React, { createContext, useContext, useState } from 'react';

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [statusScanner, setStatusScanner] = useState(null);

  return (
    <GlobalContext.Provider value={{ statusScanner, setStatusScanner }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobal = () => useContext(GlobalContext);